module.exports = __webpack_public_path__ + "static/img/brand_2.c218d35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/brand_2.jpg
// module id = tN/l
// module chunks = 1